import {
  getProductTypeBySlug,
  type ProductTypeSlug,
} from "@/lib/generated/product-types";
import type { NavLinkItem, NavMenu } from "./types";

type Trade = "buy" | "sell" | "recycle";

const MOST_TRADED: ProductTypeSlug[] = [
  "pallets",
  "gaylord-boxes",
  "ibc-totes",
  "shipping-boxes",
  "plastic-pallets",
  "plastic-drums",
  "metal-drums",
];

const TRADE_MENU_SLUGS: Record<Trade, ProductTypeSlug[]> = {
  buy: [...MOST_TRADED, "plastic-crates"],
  sell: [...MOST_TRADED, "lumber"],
  recycle: [...MOST_TRADED, "cardboard-bales"],
};

const TRADE_VERBS: Record<Trade, { label: string; hubLabel: string }> = {
  buy: { label: "Buy", hubLabel: "All buying options" },
  sell: { label: "Sell", hubLabel: "All selling options" },
  recycle: { label: "Recycle", hubLabel: "All recycling options" },
};

function sentenceCaseNoun(name: string): string {
  return name
    .split(" ")
    .map((word) => (word === word.toUpperCase() ? word : word.toLowerCase()))
    .join(" ");
}

function tradeMenu(trade: Trade): NavMenu {
  const { label, hubLabel } = TRADE_VERBS[trade];
  return {
    label,
    hub: { label: hubLabel, href: `/${trade}` },
    links: TRADE_MENU_SLUGS[trade].map((slug) => ({
      label: `${label} ${sentenceCaseNoun(getProductTypeBySlug(slug)?.pluralDisplayName ?? slug)}`,
      href: `/${trade}-${slug}`,
    })),
  };
}

const RESOURCES_LINKS: NavLinkItem[] = [
  { label: "Price Index", href: "/price-index" },
  { label: "Resource center", href: "/resources" },
  { label: "Blog", href: "/blog" },
  { label: "Grading tool", href: "/grade" },
  { label: "About us", href: "/about-us" },
  { label: "Support", href: "/contact" },
];

export const TRADE_MENUS: NavMenu[] = [
  tradeMenu("buy"),
  tradeMenu("sell"),
  tradeMenu("recycle"),
];

export const RESOURCES_MENU: NavMenu = {
  label: "Resources",
  links: RESOURCES_LINKS,
};

export const NAV_MENUS: NavMenu[] = [...TRADE_MENUS, RESOURCES_MENU];
